import React from 'react';
import '../styles/LoadingSpinner.css';

const LoadingSpinner = () => {
    return (
        <div className="wennze-app-loading-overlay">
            <div className="wennze-double-bounce-wrapper">
                <div className="wennze-bounce-circle-primary"></div>
                <div className="wennze-bounce-circle-secondary"></div>
            </div>
        </div>
    );
};

export default LoadingSpinner;